export default "__VITE_ASSET__lQ2lwyNe__"